<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="pt1" epub:type="part" role="doc-part">
<header>
<h1 class="Part-Number-pn" id="pt1"><span aria-label="17" id="pg_17" role="doc-pagebreak"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><span class="Knockout_HTF33-JuniorHeviwt_Regular_11">PART ONE</span></span></span></h1>
<h1 class="Part-Title-pt"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><b>SILENT VORTEX</b></span></h1>
</header>
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="Part-Epigraph-non-verse-pepi">The Basel Convention on the Control of Transboundary Movements of Hazardous Wastes and Their Disposal is an international treaty that was designed to reduce the movements of hazardous waste between nations, and specifically to prevent transfer of hazardous waste from developed to less developed countries (LDCs).</p>
<p class="Part-Epigraph-non-verse-last-pepi">The Convention was opened for signature on 22 March 1989, and entered into force on 5 May 1992. One hundred and seventy-nine states and the European Union are parties to the Convention.</p>
<p class="Part-Epigraph-non-verse-last-pepi">The United States, the leading producer of electronic waste, has never ratified the Convention.</p>
<p class="Part-Epigraph-Source-peps">—Wikipedia entry on “Basel Convention”</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?2a6ecee1